const React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
const {Button, Select} = require('ui-library');
const _ = require('lodash');
const API = require('../../lib/api');
const Mixins = require('../../lib/mixins');
const BillingInfo = require('./billing-info');

const SettingBilling = createClass({

  mixins: [
    Mixins.linkMixin
  ],

  propTypes: {
    billingInfoList: PropTypes.array,
    currentBillingInfoId: PropTypes.string,
    onChangeStatus: PropTypes.func,
    showSaveButton: PropTypes.bool,
    userRole: PropTypes.string
  },

  getInitialState() {
    return {
      activeBillingInfoElement: null,
      currentBillingInfoId: null,
      formStatusClass: null
    };
  },

  onChange(property, value) {
    var {onChangeStatus} = this.props;
    var {activeBillingInfoElement} = this.state;
    var formStatusClass = null;
    var isFormStatusValid = true;
    activeBillingInfoElement[property] = value;

    if (!activeBillingInfoElement.name) {
      formStatusClass = 'error';
      isFormStatusValid = false;
    }

    this.setState({
      activeBillingInfoElement: activeBillingInfoElement,
      formStatusClass: formStatusClass
    }, () => {if (typeof onChangeStatus === 'function') onChangeStatus(isFormStatusValid, activeBillingInfoElement)});
  },

  onChangeSelect(evt, index) {
    var {billingInfoList} = this.props;
    var newBillingInfoId = _.get(billingInfoList, [index, '_id']);
    this.changeBillingInfo(newBillingInfoId);
  },

  addNewBillingInfo() {
    this.changeBillingInfo(null);
  },

  changeBillingInfo(id) {
    var {onChangeStatus, billingInfoList} = this.props;
    var activeBillingInfoElement = {}
    var isFormStatusValid = true;

    if (id) { var activeBillingInfoElement = _.clone(_.find(billingInfoList, {_id: id})); }
    if (!activeBillingInfoElement || !(activeBillingInfoElement && activeBillingInfoElement.name)) { isFormStatusValid = false; }

    this.setState({
      currentBillingInfoId: activeBillingInfoElement._id,
      activeBillingInfoElement: activeBillingInfoElement
    }, ()=> {
      if (typeof onChangeStatus === 'function') onChangeStatus(isFormStatusValid, activeBillingInfoElement)
    });
  },

  saveHandler(cb) {
    var {billingInfoList} = this.props;
    var {currentBillingInfoId} = this.state;

    if (currentBillingInfoId === null && (typeof cb === 'function')) return cb();

    if (currentBillingInfoId) {
      API.auto('updateBillingInfoToCurrentAccount', this.state.activeBillingInfoElement, {
        callback: (err, res) => {
          if (typeof cb === 'function') cb(err);
        }
      });
    } else {
      API.auto('createBillingInfoToCurrentAccount', this.state.activeBillingInfoElement, {
        successMessage: 'Creado con éxito',
        callback: (err, res) => {
          if (err) return console.error(err);
          if (typeof cb === 'function') cb(err);
        }
      });
    }
  },

  render() {
    var {userRole, showSaveButton, billingInfoList} = this.props;
    var {currentBillingInfoId, activeBillingInfoElement, formStatusClass} = this.state;
    var isButtonSaveVisible = (userRole === 'agency' || userRole === 'advertiser') && currentBillingInfoId !== null && showSaveButton;
    var activeSelect = -1;

    if (currentBillingInfoId !== null) {
      activeSelect = currentBillingInfoId ? (_.findKey(billingInfoList, {_id: currentBillingInfoId}) || billingInfoList.length - 1) : (billingInfoList.length - 1);
    }

    var billingInfoSelect = <Select options={_.map(billingInfoList,el => el.name)} value={activeSelect} title='Selecciona' onChange={this.onChangeSelect} />;


    return (
      <div className='vf-settings-billing'>
        <div className='row nomargin'>
          <div className='flex'>
            <h3 className="flex-1">Datos de facturación</h3>
          </div>
          <div className='settings-form-container'>

            <div className='padding-bottom-2x padding-top-1x'>
              {billingInfoSelect}
            </div>

            <BillingInfo currentBillingInfo={activeBillingInfoElement} formStatusClass={formStatusClass} onChange={this.onChange} />

            { isButtonSaveVisible &&
              <div className='md-12'>
                <Button color='primary' onClick={this.saveHandler.bind(null)}>Guardar datos de facturación</Button>
              </div>
            }
          </div>

        </div>
      </div>
    );
  }
});

module.exports = SettingBilling;
